/**
 * Material Management - Constants and Utility Functions
 * Shared across all material-related components
 */

// Material Categories with styling
export const MATERIAL_CATEGORIES = [
  { id: "construction", label: "Construction Materials", color: "primary" },
  { id: "machinery_spares", label: "Machinery Spares", color: "accent" },
  { id: "machinery_consumables", label: "Machinery Consumables", color: "warning" },
  { id: "miscellaneous", label: "Miscellaneous", color: "slate" }
];

// Check if a material is fuel (Diesel, Petrol, HSD, etc.)
export const isFuelMaterial = (materialName) => {
  if (!materialName) return false;
  const fuelKeywords = ['diesel', 'petrol', 'hsd', 'fuel', 'lubricant', 'oil', 'grease'];
  return fuelKeywords.some(keyword => materialName.toLowerCase().includes(keyword));
};

// Get category info by ID
export const getCategoryInfo = (categoryId) => {
  return MATERIAL_CATEGORIES.find(c => c.id === categoryId) || { label: "Construction Materials", color: "primary" };
};

// Initial form states
export const getInitialMaterialForm = () => ({
  name: "",
  category: "construction",
  unit: "MT",
  opening_stock: "",
  rate: "",
  minimum_stock: ""
});

export const getInitialInwardForm = () => ({
  material_id: "",
  material_requirement_id: "",
  category: "construction",
  date: new Date().toISOString().split('T')[0],
  quantity: "",
  entered_rate: "",
  challan_number: "",
  supplier_name: "",
  vehicle_number: "",
  received_by: "",
  quality_status: "Approved",
  remarks: ""
});

export const getInitialOutwardForm = () => ({
  material_id: "",
  material_requirement_id: "",
  category: "construction",
  date: new Date().toISOString().split('T')[0],
  quantity: "",
  issued_to: "",
  purpose: "",
  remarks: "",
  is_fuel_issue: false,
  equipment_id: "",
  fuel_type: ""
});

export const getInitialRequirementForm = () => ({
  material_id: "",
  planned_quantity: "",
  is_lumpsum: false,
  management_rate: "",
  rate_variance_allowed: "3",
  remarks: ""
});

export const getInitialOpeningStockForm = () => ({
  material_id: "",
  quantity: "",
  rate: "",
  remarks: ""
});
